import _ from 'lodash';
import classNames from 'classnames';
import objectAssign from 'object-assign';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/eventActions';
import { Link, withRouter } from 'react-router';
import RichTextEditor from 'react-rte';
import FontAwesome from 'react-fontawesome';
import toastr from 'toastr';
import HeaderImage from '../../components/common/HeaderImage';
import RichTextInput from '../../components/common/RichTextInput';
import TextInput from '../../components/common/TextInput';
import CheckboxInput from '../../components/common/CheckboxInput';
import DateTimeInput from '../../components/common/DateTimeInput';
import ManageEventTeam from './ManageEventTeam';

class ManageEvent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.shouldUpdateEventDetails = this.shouldUpdateEventDetails.bind(this);
    this.updateEventForm = this.updateEventForm.bind(this);
    this.updateTimeField = this.updateTimeField.bind(this);
    this.updateRichField = this.updateRichField.bind(this);
    this.askBeforeExit = this.askBeforeExit.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.copyEvent = this.copyEvent.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.imageFieldChange = this.imageFieldChange.bind(this);
    let eventDetails = {description: ''};
    if(props.eventId) {
      eventDetails = objectAssign({}, props.eventDetails);
    }
    this.state = {
      eventDetails: eventDetails,
      loadingEvents: false,
      richDescription: RichTextEditor.createValueFromString(
        (eventDetails.description || ''),
        'html'
      ),
      richRegDescription: RichTextEditor.createValueFromString(
        (eventDetails.reg_description || ''),
        'html'
      ),
      richConDescription: RichTextEditor.createValueFromString(
        (eventDetails.contenders_description || ''),
        'html'
      ),
      errors: {},
    };
  }

  componentWillMount() {
    if(this.props.eventId) {
      this.props.actions.loadEventTeamSettings(this.props.eventId);
    }
    this.props.router.setRouteLeaveHook(this.props.route, () => {
      return this.askBeforeExit();
    });
  }

  componentWillReceiveProps(nextProps) {
    if(this.shouldUpdateEventDetails(nextProps)) {
      this.setState({
        eventDetails: nextProps.eventDetails,
        errors: {},
        loadingEvents: nextProps.loadingEvents,
        richDescription: RichTextEditor.createValueFromString(
          nextProps.eventDetails.description || '',
          'html'
        ),
        richRegDescription: RichTextEditor.createValueFromString(
          nextProps.eventDetails.reg_description || '',
          'html'
        ),
        richConDescription: RichTextEditor.createValueFromString(
          nextProps.eventDetails.contenders_description || '',
          'html'
        ),
      });
    } else if(!_.isEqual(this.props.errors, nextProps.errors)) {
      this.setState({
        loadingEvents: false,
        errors: nextProps.errors,
      });
    }
  }

  shouldUpdateEventDetails(nextProps) {
    let updated = this.props.eventDetailsUpdated !== nextProps.eventDetailsUpdated;
    return _.every([updated], (item) => item === true);
  }

  updateEventForm(event) {
    let eventDetails = objectAssign({}, this.state.eventDetails);
    let value = event.target.type == 'checkbox' ? event.target.checked : event.target.value;
    eventDetails[event.target.name] = value;
    return this.setState({
      eventDetails: eventDetails
    });
  }

  updateTimeField(field, time) {
    let eventDetails = objectAssign({}, this.state.eventDetails);
    eventDetails[field] = time;
    return this.setState({
      eventDetails: eventDetails
    });
  }

  updateRichField(field, value) {
    return this.setState({
      [field]: value
    });
  }

  uploadImage(e) {
    e.preventDefault();
    this.setState({
      loadingEvents: true,
    });
    toastr.info('Lagrer bilde');
    if (this.props.eventId) {
      this.props.actions.updateEventImage(this.props.eventId, this.state.eventDetails['image_upload']);
    }
  }

  imageFieldChange(event) {
    let eventDetails = objectAssign({}, this.state.eventDetails);
    eventDetails['image'] = URL.createObjectURL(event.target.files[0]);
    eventDetails['image_upload'] = event.target.files[0];
    this.setState({
      eventDetails: eventDetails
    });
  }

  submitForm(e) {
    e.preventDefault();
    let eventDetails = objectAssign({}, this.state.eventDetails);
    eventDetails['description'] = this.state.richDescription.toString('html');
    eventDetails['reg_description'] = this.state.richRegDescription.toString('html');
    eventDetails['contenders_description'] = this.state.richConDescription.toString('html');
    this.setState({
      loadingEvents: true,
    });
    toastr.info('Lagrer');
    if (this.props.eventId) {
      this.props.actions.updateEvent(eventDetails);
    } else {
      this.props.actions.createEvent(eventDetails);
    }
  }

  copyEvent(e) {
    if (!confirm('Bekreft at du ønsker å kopiere dette arrangementet.')) {
      e.preventDefault();
      return false;
    }
    this.props.actions.copyEvent(this.props.eventDetails);
  }

  askBeforeExit() {
    let changed = !_.isEqual(this.props.eventDetails, this.state.eventDetails);
    let descChanged = this.props.eventDetails.description != this.state.richDescription.toString('html');
    if (this.props.eventId && (changed || descChanged ) && !confirm('Ønsker du å gå tilbake uten å lagre?')) {
      return false;
    } else {
      return true;
    }
  }

  render() {
    let details = this.state.eventDetails;
    return (
      <div className="manage-event-page-container container">
        <div className="row">
          <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
            <div className="panel panel-default">
              <div className="image-upload-wrapper">
                <form onSubmit={this.uploadImage}>
                  {details.id && <label htmlFor="upload-image" className="select-image-label">
                    <HeaderImage
                      headerLink={details.image}/>
                  </label>}
                  {!details.id && <HeaderImage
                    headerLink={details.image}/>}
                  <div className={classNames('form-group image-upload', {
                      hidden: !details.id
                    })}>
                      <div className="col-sm-8">
                        <input
                          type="file" id="upload-image"
                          onChange={this.imageFieldChange}
                          className="form-control"
                          accept=".png,.jpg,.jpeg"
                          />
                      </div>
                      <div className="col-sm-4">
                        <input type="submit"
                          value="Las opp"
                          disabled={this.state.loadingEvents}
                          className="btn btn-primary btn-block"/>
                      </div>
                  </div>
                </form>
              </div>
              <div className="panel-body">
                <form onSubmit={this.submitForm}>
                  <input type="submit" className="hidden"/>
                  <TextInput
                    name="name"
                    error={this.state.errors.name}
                    inputClass="input-lg"
                    placeholder="Arrangementnavn"
                    onChange={this.updateEventForm}
                    value={details.name}
                    />
                  <hr/>
                  <CheckboxInput
                    label="Publisert"
                    alertClass={'alert alert-' + (details.published ? 'success' : 'danger')}
                    labelClass={'center-block'}
                    name="published"
                    error={this.state.errors.published}
                    onChange={this.updateEventForm}
                    checked={details.published}
                    value={'_' + details.published} />
                  <div className="form-group row">
                    <div className="col-sm-6">
                      <DateTimeInput
                        label="Startdato"
                        name="start_date"
                        error={this.state.errors.start_date}
                        inputClass=""
                        onChange={this.updateTimeField}
                        value={details.start_date}
                        />

                    </div>
                    <div className="col-sm-6">
                      <DateTimeInput
                        label="Sluttdato"
                        name="end_date"
                        error={this.state.errors.end_date}
                        inputClass=""
                        onChange={this.updateTimeField}
                        value={details.end_date}
                        />
                    </div>
                  </div>
                  <div className="form-group">
                    <RichTextInput
                      label="Beskrivelse"
                      name={'description'}
                      richName={'richDescription'}
                      error={this.state.errors.description}
                      value={this.state.richDescription}
                      onChange={this.updateRichField} />
                  </div>
                  <div className="form-group">
                    <RichTextInput
                      label="Tekst over påmeldingsskjema"
                      name={'reg_description'}
                      richName={'richRegDescription'}
                      error={this.state.errors.reg_description}
                      value={this.state.richRegDescription}
                      onChange={this.updateRichField} />
                  </div>
                  <div className="form-group">
                    <RichTextInput
                      label="Tekst over deltagerregistrring"
                      name={'contenders_description'}
                      richName={'richConDescription'}
                      error={this.state.errors.contenders_description}
                      value={this.state.richConDescription}
                      onChange={this.updateRichField} />
                  </div>
                  <TextInput
                    label="Maks antall klubber"
                    name="max_clubs"
                    error={this.state.errors.max_clubs}
                    onChange={this.updateEventForm}
                    value={details.max_clubs}
                    />
                  <TextInput
                    label="Maks antall deltagere (pr. klubb)"
                    name="max_contenders"
                    error={this.state.errors.max_contenders}
                    onChange={this.updateEventForm}
                    value={details.max_contenders}
                    />
                  <TextInput
                    label="Pris pr deltager"
                    name="price_contender"
                    error={this.state.errors.price_contender}
                    onChange={this.updateEventForm}
                    value={details.price_contender}
                    />
                  <TextInput
                    label="Artikkel nr. (Pris pr deltager)"
                    name="contender_article_number"
                    error={this.state.errors.contender_article_number}
                    onChange={this.updateEventForm}
                    value={details.contender_article_number}
                    />
                  <h3 className="page-header">
                    Sted
                  </h3>
                  <TextInput
                    label="Sted"
                    name="venue_name"
                    error={this.state.errors.venue_name}
                    onChange={this.updateEventForm}
                    value={details.venue_name}
                    />
                  <TextInput
                    label="Adresse"
                    name="venue_address"
                    error={this.state.errors.venue_address}
                    onChange={this.updateEventForm}
                    value={details.venue_address}
                    />
                  <div className="row">
                    <div className="col-sm-3">
                      <TextInput
                        label="Postnummer"
                        name="venue_zip"
                        error={this.state.errors.venue_zip}
                        onChange={this.updateEventForm}
                        value={details.venue_zip}
                        />
                    </div>
                    <div className="col-sm-3">
                      <TextInput
                        label="Kommune"
                        name="venue_municipality"
                        error={this.state.errors.venue_municipality}
                        onChange={this.updateEventForm}
                        value={details.venue_municipality}
                        />
                    </div>
                    <div className="col-sm-3">
                      <TextInput
                        label="Fylke"
                        name="venue_county"
                        error={this.state.errors.venue_county}
                        onChange={this.updateEventForm}
                        value={details.venue_county}
                        />
                    </div>
                    <div className="col-sm-3">
                      <TextInput
                        label="Land"
                        name="venue_country"
                        error={this.state.errors.venue_country}
                        onChange={this.updateEventForm}
                        value={details.venue_country}
                        />
                    </div>
                  </div>
                  <h3 className="page-header">
                    Påmeldingsfrister
                  </h3>
                  <DateTimeInput
                    label="Påmeldingsfrist"
                    name="first_registration_deadline"
                    error={this.state.errors.first_registration_deadline}
                    inputClass=""
                    helpText={"Frist for registrering av nye påmeldinger."}
                    onChange={this.updateTimeField}
                    value={details.first_registration_deadline}
                    />
                  <DateTimeInput
                    label="Endringsfrist"
                    name="second_registration_deadline"
                    error={this.state.errors.second_registration_deadline}
                    inputClass=""
                    helpText={"Kun endringer tillates, ikke nye påmeldinger."}
                    onChange={this.updateTimeField}
                    value={details.second_registration_deadline}
                    />
                  <DateTimeInput
                    label="Godkjenningsfrist"
                    name="third_registration_deadline"
                    error={this.state.errors.third_registration_deadline}
                    inputClass=""
                    helpText={"Endringer krever godkjenning fra arrangør"}
                    onChange={this.updateTimeField}
                    value={details.third_registration_deadline}
                    />
                  <DateTimeInput
                    label="Siste endringsfrist"
                    name="final_registration_deadline"
                    error={this.state.errors.final_registration_deadline}
                    inputClass=""
                    helpText={"Ingen endringer tillat (kun endringer fra admin/arrangør)"}
                    onChange={this.updateTimeField}
                    value={details.final_registration_deadline}
                    />
                  <div className="alert alert-info">
                    <p>{'Hvis ikke ønsker å tillate endringer etter '+
                     'påmeldingsfristen la feltetene for endrigner stå tomt.'}
                    </p>
                    <p>{'NB. Admin/arrangør kan altid gjøre endirnger og '+
                    'registrere nye påmeldinger. Tidsfristene over er ment for'+
                    ' personer eller klubber som melder seg på arrangementet.'}
                    </p>
                  </div>
                </form>
              </div>
              <div className="panel-footer clearfix">
                <span className="pull-right">
                  {details.id && <span>
                    <button className="btn btn-default"
                      disabled={this.state.loadingEvents}
                      onClick={(e) => {this.copyEvent(e);}} >
                      <FontAwesome name="copy" />
                      {' Kopier'}
                    </button>
                    &emsp;
                  </span>}
                  <button className="btn btn-primary"
                    disabled={this.state.loadingEvents}
                    onClick={this.submitForm} >
                    <FontAwesome name="save" />
                    {' Lagre'}
                  </button>
                </span>
                {details.id && <span>
                  <Link className="btn btn-default"
                    to={'/arrangement/' + (details.id ? details.id : '')}>
                    Tilbake
                  </Link>
                </span>}
              </div>
            </div>

            <div className="page-header">
              <h3>Grupperinger</h3>
            </div>
            {!this.props.eventId && <div className="alert alert-info">
              {"Du må opprette/lagre eventet før du kan legge til grupperinger"}
            </div>}
            {this.props.eventId && <div>
              {this.props.teamList.map((team, index) =>{
                return (<ManageEventTeam key={team.identifier}
                  teamIndex={index}
                  eventId={this.props.eventId}
                  details={team} />);
              })}
              <button className="btn btn-default btn-block"
                onClick={() => {
                  this.props.actions.addNewTeam(this.props.eventId);}
                }>
                {'Legg til gruppering'}
              </button>
            </div>}

          </div>
        </div>
      </div>
    );
  }
}

ManageEvent.propTypes = {
  actions: PropTypes.object.isRequired,
  eventDetails: PropTypes.object.isRequired,
  teamList: PropTypes.array.isRequired,
  errors: PropTypes.object.isRequired,
  eventDetailsUpdated: PropTypes.number.isRequired,
  eventId: PropTypes.string,
  loadingEvents: PropTypes.bool,
  router: PropTypes.object.isRequired,
  route: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  return {
    eventId: ownProps.params.eventId,
    loadingEvents: state.events.loadingEvents,
    errors: state.events.errors,
    eventDetails: state.events.eventDetails,
    eventDetailsUpdated: state.events.eventDetailsUpdated,
    teamList: state.events.teamList,
    teamListUpdated: state.events.teamListUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageEvent));



/** WEBPACK FOOTER **
 ** ./src/containers/events/ManageEvent.js
 **/